import { useMutation } from '@tanstack/react-query'

import { Methods } from '@/api/v1/employee/login'
import { aspidaClient } from '@/lib/aspida'
import { MutationConfig } from '@/lib/react-query'

export type EmployeeLoginDTO = {
  data: Methods['post']['reqBody']
}

export const employeeLogin = ({ data }: EmployeeLoginDTO) => {
  return aspidaClient.v1.employee.login.$post({ body: data })
}

type UseEmployeeLoginOptions = {
  config?: MutationConfig<typeof employeeLogin>
}

export const useEmployeeLogin = ({ config }: UseEmployeeLoginOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: employeeLogin,
  })
}
